import { useState, useEffect } from "react";

export function TechHintBeacon({ playerCount = 4 }) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setPhase((p) => (p + 1) % 3);
    }, 1000);
    return () => clearInterval(id);
  }, []);

  const placeLabel = playerCount >= 5 ? "Salle technique" : "Bureau de Samir";

  const labels = [
    placeLabel,           // "Bureau de Samir" ou "Salle technique"
    "Tiroir",
    "Doc câblage",
  ];

  const label = labels[phase];

  return (
    <div
      className="
        pointer-events-none
        absolute
        left-[42.95%]
        top-[20.8%]
        flex items-center justify-center
        lightCode
        lightCodeOrange
        rounded
      "
    >
      <div
        className="
          w-full h-full
          bg-orange-300/90
          shadow-[0_0_18px_rgba(252,211,77,0.9)]
          transition-all duration-150
          flex items-center justify-center
          rounded
          px-2
        "
      >
        <span className="text-[13px] tracking-[0.2em] text-amber-950/80 font-semibold text-center">
          {label}
        </span>
      </div>
    </div>
  );
}